










import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import SCRenderBase from './SCRenderBase.vue'
import { SCRenderMixin } from './SCRenderMixin'

@Component({
  components: { SCRenderBase }
})
export default class SCRender4 extends Mixins(SCRenderMixin) {}
